// Prevent vertical scroll while using flickity sliders
(function () {
  var e = !1;
  var t;

  document.body.addEventListener('touchstart', function (i) {
    if (!i.target.closest('.flickity-slider')) {
      return (e = !1);
      void 0;
    }
    e = !0;
    t = {
      x: i.touches[0].pageX,
      y: i.touches[0].pageY,
    };
  });

  document.body.addEventListener(
    'touchmove',
    function (i) {
      if (e && i.cancelable) {
        var n = {
          x: i.touches[0].pageX - t.x,
          y: i.touches[0].pageY - t.y,
        };
        Math.abs(n.x) > Flickity.defaults.dragThreshold && i.preventDefault();
      }
    },
    { passive: !1 },
  );
})();


/* Simple appearence with animation AN-1*/
function openNav() {
  document.getElementById("mySidenav").style.width = "250px";
}
function closeNav() {
  document.getElementById("mySidenav").style.width = "0";
}
/* Simple appearence with animation AN-1*/

function tabHeight() {
  let tab = document.querySelector(
    ".template-collection section.tab-content.section .tab"
  );
  let height;

  if (tab) {
    height = tab.clientHeight - 1;
    document.documentElement.style.setProperty("--tab-height", height + "px");
  } else {
    document.documentElement.style.setProperty("--tab-height", 0 + "px");
  }
}

function whatsappPopup() {
  let btn = document.getElementById('whatsapp-popup-trigger');
  let modal = document.getElementById('whatsappByLocation');

  if(!modal) return;

  let close = modal.querySelector('.close-btn');

  [close,btn].forEach(listen => {
    listen.addEventListener('click', function(){
      modal.classList.toggle('show');
    });
  })
}

function collectionRestrictFormSubmit() {
  const mainForm = document.querySelector('.collection-restriction-form');
  if (!mainForm) return;

  let header = document.querySelector('header.header');

  if (localStorage.getItem('registered_already') === 'true') {
    document.body.classList.add('collectionRestrictFormSubmit');
    header?.classList.remove('header--transparent');
    document.body.classList.remove('header-transparent');
    return;
  }

  const observeThankClass = () => {
    const targetNode = mainForm.querySelector('.ets_cf_box');
    if (!targetNode) return;

    const thankObserver = new MutationObserver((mutationsList) => {
      for (const mutation of mutationsList) {
        if (mutation.type === 'attributes' && targetNode.classList.contains('ets_cf_only_thank')) {
          document.body.classList.add('collectionRestrictFormSubmit');
          if (!localStorage.getItem('registered_already')) {
            localStorage.setItem('registered_already', 'true');
            header?.classList.remove('header--transparent');
            document.body.classList.remove('header-transparent');
            window.scrollTo(0, 0);
          }
          thankObserver.disconnect();
        }
      }
    });

    thankObserver.observe(targetNode, {
      attributes: true,
      attributeFilter: ['class'],
    });
  };

  const mainObserver = new MutationObserver((mutationsList) => {
    for (const mutation of mutationsList) {
      if (mutation.type === 'attributes' && mainForm.classList.contains('ets_cf_loaded')) {
        mainObserver.disconnect();
        observeThankClass();
      }
    }
  });

  mainObserver.observe(mainForm, {
    attributes: true,
    attributeFilter: ['class'],
  });
}

function mobileSlider() {
  if (
    !window.matchMedia("(max-width: 768px)").matches ||
    !document.body.classList.contains("template-collection") ||
    typeof Flickity === "undefined"
  )
    return;

  const slidersWrappers = document.querySelectorAll(".product-item-mobile-media");
  if (!slidersWrappers.length) return;

  slidersWrappers.forEach((wrapper) => {
    wrapper.style.display = "block";

    if (wrapper.flickityInstance) {
      wrapper.flickityInstance.destroy();
    }

    setTimeout(function () {
      wrapper.flickityInstance = new Flickity(wrapper, {
        wrapAround: true,
        contain: true,
        cellAlign: "left",
        pageDots: true,
        prevNextButtons: false,
        adaptiveHeight: true,
      });
    }, 1000);
  });
}



window.shivSlider = mobileSlider;

document.addEventListener("DOMContentLoaded", function () {
  tabHeight();
  whatsappPopup();
  collectionRestrictFormSubmit();
  mobileSlider();
});
